<template>
  <div id="PrintOrder" class="print-preview">
    <div class="print-title">采购入库单</div>
    <el-descriptions
      title=""
      size="small"
      class="m-b-10"
      style="width: 80%; max-width: 800px; min-width: 500px"
    >
      <el-descriptions-item label="业务类型">{{
        order.business_type
      }}</el-descriptions-item>
      <el-descriptions-item label="发票号">
        {{ order.invoice_number }}
      </el-descriptions-item>
      <el-descriptions-item label="订单号">{{
        order.number
      }}</el-descriptions-item>
      <el-descriptions-item label="入库单号">
        {{ order.stockin_number }}
      </el-descriptions-item>
      <el-descriptions-item label="入库日期">
        {{ order.stock_time }}
      </el-descriptions-item>
      <el-descriptions-item label="仓库">
        {{ order.stockroom_name }}
      </el-descriptions-item>
      <el-descriptions-item label="入库类别">
        {{ order.stockin_category }}
      </el-descriptions-item>
      <el-descriptions-item label="部门">
        {{ order.department }}
      </el-descriptions-item>
      <el-descriptions-item label="业务员">
        {{ order.saler }}
      </el-descriptions-item>
      <el-descriptions-item label="采购类型">{{
        order.purchase_category
      }}</el-descriptions-item>
      <el-descriptions-item label="供货单位">
        {{ order.supplier }}
      </el-descriptions-item>
      <el-descriptions-item label="备注">
        {{ order.remark }}
      </el-descriptions-item>
    </el-descriptions>

    <!-- <table style="width: 100%">
      <tr>
        <th>存货编码</th>
        <th>存货名称</th>
        <th>规格</th>
        <th>型号/倒角</th>
        <th>计量单位</th>
        <th>数量</th>
        <th>单价</th>
        <th>税额</th>
        <th>金额</th>
        <th>含税单价</th>
        <th>价税合计</th>
        <th>税率</th>
      </tr>
      <tr :key="item.id" v-for="item in order.items">
        <td>存货编码</td>
        <td>存货名称</td>
        <td>规格</td>
        <td>型号/倒角</td>
        <td>计量单位</td>
        <td>数量</td>
        <td>单价</td>
        <td>税额</td>
        <td>金额</td>
        <td>含税单价</td>
        <td>价税合计</td>
        <td>税率</td>
      </tr>
      <tr :key="item.id" v-for="item in order.items">
        <td>存货编码</td>
        <td>存货名称</td>
        <td>规格</td>
        <td>型号/倒角</td>
        <td>计量单位</td>
        <td>数量</td>
        <td>单价</td>
        <td>税额</td>
        <td>金额</td>
        <td>含税单价</td>
        <td>价税合计</td>
        <td>税率</td>
      </tr>
      <tr :key="item.id" v-for="item in order.items">
        <td>存货编码</td>
        <td>存货名称</td>
        <td>规格</td>
        <td>型号/倒角</td>
        <td>计量单位</td>
        <td>数量</td>
        <td>单价</td>
        <td>税额</td>
        <td>金额</td>
        <td>含税单价</td>
        <td>价税合计</td>
        <td>税率</td>
      </tr>
    </table> -->

    <el-table
      border
      :data="order.items"
      show-summary
      :summary-method="getSummaries"
      ref="table"
    >
      <el-table-column
        label="存货编码"
        prop="code"
        align="center"
        min-width="90"
      >
      </el-table-column>
      <el-table-column
        label="存货名称"
        prop="name"
        align="center"
        min-width="90"
      >
      </el-table-column>
      <el-table-column
        label="规格"
        prop="specification"
        align="center"
        min-width="90"
      >
      </el-table-column>
      <el-table-column
        label="型号/倒角"
        prop="model_number"
        align="center"
        min-width="90"
      >
      </el-table-column>
      <el-table-column label="计量单位" prop="unit" align="center">
      </el-table-column>
      <el-table-column label="数量" prop="number" align="center">
      </el-table-column>
      <el-table-column label="单价" prop="no_tax_price" align="right">
        <template slot-scope="scope">
          <span>{{ scope.row.no_tax_price.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税额" align="right" prop="total_tax">
        <template slot-scope="scope">
          <span>{{ scope.row.total_tax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="right" prop="total_no_tax_price">
        <template slot-scope="scope">
          <span>{{ scope.row.total_no_tax_price.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="含税单价" prop="tax_price" align="right">
        <template slot-scope="scope">
          <span>{{ scope.row.tax_price.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="价税合计" align="right" prop="total_price">
        <template slot-scope="scope">
          <span>{{ scope.row.total_price.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税率" prop="tax_rate" align="right">
        <template slot-scope="scope">
          <span>{{ scope.row.tax_rate.toFixed(2) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-descriptions title="" size="small" class="mt-100">
      <el-descriptions-item label="制单人" :span="2">{{
        order.user.name
      }}</el-descriptions-item>
      <el-descriptions-item label="记账人">{{
        order.bookkeeper
      }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { CommodityCategoryMap } from '../../../config/global'

export default {
  props: {
    order: {
      type: Object,
    },
  },
  data() {
    return {
      CommodityCategoryMap,
    }
  },
  computed: {},
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }

        if (
          ['total_tax', 'total_no_tax_price', 'total_price'].includes(
            column.property
          )
        ) {
          const values = data.map((item) => Number(item[column.property]))
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)

            sums[index] = sums[index].toFixed(2)
          } else {
            sums[index] = ''
          }
        }
      })

      return sums
    },
  },
}
</script>

<style scoped>
.print-preview {
  display: none;
  color: #000;
}

.print-title {
  text-align: center;
  font-size: 18px !important;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>

<style>
@media print {
  .print-preview {
    display: block !important;
  }

  html,
  body,
  div {
    font-size: 14px !important;
  }

  table {
    table-layout: auto !important;
  }

  .el-table__cell,
  .el-table--border {
    display: table-cell !important;
    border-color: #333 !important;
  }

  .el-table__header-wrapper .el-table__header {
    width: 100% !important;
  }

  .el-table__body-wrapper .el-table__body {
    width: 100% !important;
  }

  .el-table__footer-wrapper .el-table__footer {
    width: 100% !important;
  }
}
</style>